module.exports = __webpack_public_path__ + "img/pic1.1bc1f7ad.png";